import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useAssignedCommodityList(mappingId: string) {
  const { userMappingService } = useService();

  const { data, isFetching } = useQuery([QUERY_KEYS.commodityUserMappings, mappingId], () =>
    userMappingService.getAssignedCommodities(mappingId)
  );

  return { assignedCommodities: data, isFetching } as const;
}
